var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nr_container_content mt-60 " },
    [
      _c("v-modal-contents", {
        ref: "modal_contents_successfully",
        staticClass: "modal_contents_successfully ",
        scopedSlots: _vm._u([
          {
            key: "close",
            fn: function () {
              return [_c("span")]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title" }, [
                  _c("div", { staticClass: "h2_title h2_title--modal" }, [
                    _vm._v("Ваши ответы приняты"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use" }, [
                  _c("p", { staticClass: "green_messs" }, [
                    _vm._v("Благодарим вас за уделенное время"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "mt-4 btn v-btn btn_poll",
                      attrs: { href: "/" },
                    },
                    [_vm._v("Хорошо")]
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("v-modal-contents", {
        ref: "modal_alert",
        staticClass: "modal_alert",
        scopedSlots: _vm._u([
          {
            key: "close",
            fn: function () {
              return [_c("span")]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title" }, [
                  _c("div", { staticClass: "h2_title h2_title--modal" }, [
                    _vm._v("Пожалуйста, ответьте на все вопросы"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "terms_of_use" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "mt-4 btn_poll",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.closeAlertModal.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("\n                    Хорошо\n                ")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "poll",
          class: _vm.validAll ? "valid" : "noValid",
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c("v-text-field", {
            staticClass: "mb-20",
            attrs: {
              label: "1. Название вашей компании",
              rules: _vm.rulesField,
              required: "",
            },
            model: {
              value: _vm.companyName,
              callback: function ($$v) {
                _vm.companyName = $$v
              },
              expression: "companyName",
            },
          }),
          _vm._v(" "),
          _c("v-text-field", {
            staticClass: "mb-20",
            attrs: {
              label: "2. Имя и фамилия",
              rules: _vm.rulesField,
              required: "",
            },
            model: {
              value: _vm.contactPerson,
              callback: function ($$v) {
                _vm.contactPerson = $$v
              },
              expression: "contactPerson",
            },
          }),
          _vm._v(" "),
          _c("v-text-field", {
            staticClass: "mb-20",
            attrs: {
              label: "3. Должность",
              rules: _vm.rulesField,
              required: "",
            },
            model: {
              value: _vm.position,
              callback: function ($$v) {
                _vm.position = $$v
              },
              expression: "position",
            },
          }),
          _vm._v(" "),
          _c("v-text-field", {
            staticClass: "mb-20",
            attrs: {
              label: "4. Электронная почта",
              rules: _vm.emailRules,
              required: "",
              type: "email",
            },
            model: {
              value: _vm.email,
              callback: function ($$v) {
                _vm.email = $$v
              },
              expression: "email",
            },
          }),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesField,
                required: "",
                label:
                  "5.\tНасколько вы удовлетворены сроками поставки товара (с учётом производства и логистики) с момента размещения заказа? (от 1 до 10, где 1 – не удовлетворён, 10 – полностью удовлетворен)",
              },
              model: {
                value: _vm.deliveryTimes,
                callback: function ($$v) {
                  _vm.deliveryTimes = $$v
                },
                expression: "deliveryTimes",
              },
            },
            _vm._l(10, function (n) {
              return _c("v-radio", {
                key: "quality-" + n,
                attrs: { color: "red", label: String(n), value: String(n) },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesField,
                required: "",
                label:
                  "6. Насколько вы удовлетворены внешним видом упаковки? (от 1 до 10, где 1 – не удовлетворён, 10 – полностью удовлетворен)",
              },
              model: {
                value: _vm.packagingAppearance,
                callback: function ($$v) {
                  _vm.packagingAppearance = $$v
                },
                expression: "packagingAppearance",
              },
            },
            _vm._l(10, function (n) {
              return _c("v-radio", {
                key: "next-" + n,
                attrs: { color: "red", label: String(n), value: String(n) },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c("v-textarea", {
            attrs: {
              placeholder: "Ваш ответ...",
              color: "red",
              label:
                "7. Укажите, с какими повреждениями упаковки вы сталкивались ",
              rules: _vm.textareaRules,
              required: "",
              rows: "1",
              "auto-grow": "",
            },
            model: {
              value: _vm.packagingDamage,
              callback: function ($$v) {
                _vm.packagingDamage = $$v
              },
              expression: "packagingDamage",
            },
          }),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesField,
                required: "",
                label:
                  "8.\tНасколько вы удовлетворены качеством оформления документов по поставке? (от 1 до 10, где 1 – не удовлетворён, 10 – полностью удовлетворен)",
              },
              model: {
                value: _vm.documentQuality,
                callback: function ($$v) {
                  _vm.documentQuality = $$v
                },
                expression: "documentQuality",
              },
            },
            _vm._l(10, function (n) {
              return _c("v-radio", {
                key: "satisf-" + n,
                attrs: { color: "red", label: String(n), value: String(n) },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesField,
                required: "",
                label:
                  "9.\tКак часто у вас возникали расхождения по количеству или ассортименту поставляемого товара (пересорт, излишек, недовоз)? (от 1 до 10, где 1 – постоянно, 10 – никогда)",
              },
              model: {
                value: _vm.mixedUpVarieties,
                callback: function ($$v) {
                  _vm.mixedUpVarieties = $$v
                },
                expression: "mixedUpVarieties",
              },
            },
            _vm._l(10, function (n) {
              return _c("v-radio", {
                key: "rec-" + n,
                attrs: { color: "red", label: String(n), value: String(n) },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesField,
                required: "",
                label:
                  "10. Насколько вас устраивает текущий ассортимент, предлагаемый нашей компанией? (от 1 до 10, где 1 — много позиций отсутствует, 10 — есть всё необходимое) ",
              },
              model: {
                value: _vm.currentAssortment,
                callback: function ($$v) {
                  _vm.currentAssortment = $$v
                },
                expression: "currentAssortment",
              },
            },
            _vm._l(10, function (n) {
              return _c("v-radio", {
                key: "rec-" + n,
                attrs: { color: "red", label: String(n), value: String(n) },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c("v-textarea", {
            attrs: {
              placeholder: "Ваш ответ...",
              color: "red",
              label:
                "11. Какие дополнительные категории товаров или конкретные позиции вы хотели бы видеть в нашем ассортименте?",
              rules: _vm.textareaRules,
              required: "",
              rows: "1",
              "auto-grow": "",
            },
            model: {
              value: _vm.productOffers,
              callback: function ($$v) {
                _vm.productOffers = $$v
              },
              expression: "productOffers",
            },
          }),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesField,
                required: "",
                label:
                  "12. Оцените работу сотрудника отдела продаж с точки зрения качества обслуживания (от 1 до 10, где 1 — крайне недоволен, 10 — полностью доволен)",
              },
              model: {
                value: _vm.serviceQuality,
                callback: function ($$v) {
                  _vm.serviceQuality = $$v
                },
                expression: "serviceQuality ",
              },
            },
            _vm._l(10, function (n) {
              return _c("v-radio", {
                key: "rec-" + n,
                attrs: { color: "red", label: String(n), value: String(n) },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c("v-textarea", {
            attrs: {
              placeholder: "Ваш ответ...",
              color: "red",
              label: "13. Ваши предложения по улучшению нашей работы/продукции",
              rules: _vm.textareaRules,
              required: "",
              rows: "1",
              "auto-grow": "",
            },
            model: {
              value: _vm.improvementSuggestions,
              callback: function ($$v) {
                _vm.improvementSuggestions = $$v
              },
              expression: "improvementSuggestions",
            },
          }),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "mt-30 btn-red",
              attrs: { color: "#FA4237" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.submitSurvey.apply(null, arguments)
                },
              },
            },
            [_vm._v("Отправить")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }